// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 引入 ElementUI 组件库
import ElementUI from 'element-ui'
// 引入 ElementUI 主题 CSS，不然一些图标和样式不生效
import 'element-ui/lib/theme-chalk/index.css'

import { message } from '@/utils/resetMessage'; // 自定义重置 message

Vue.use(ElementUI);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js